/* Ardor Sticker Builder: proof approval box, signature and signed proof PDF. Ardor Printing.
   Same flow and wording as the Ardor Banner Builder (see Builders on ardorprinting.com - Proof & Order Files Standard). */
(function () {
'use strict';
if (window.ArdorStickerApprove) return;

var me = document.currentScript;
var CONF = {
  pdfUrl: me ? me.getAttribute('data-pdf') : '',
  logoUrl: me ? me.getAttribute('data-logo') : '',
  cartAddUrl: '/cart/add.js'
};
var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
var STATEMENTS = ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'];
var FOOTER = 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com';
var DISCLAIMER = 'Colors on screen and on this proof may differ slightly from the printed stickers. Cut line position may vary slightly.';

var dlg = null, ctl = null;
var sig = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'type' };

function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
function stampFile(d) {
  var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
  return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
}

var HTML =
  '<form class="asb-dialog__form" data-asb-form novalidate>' +
  '<button type="button" class="asb-dialog__close" data-asb-close aria-label="Close">&times;</button>' +
  '<h2 class="asb-dialog__title" id="AsbApproveTitle">Review and approve your proof</h2>' +
  '<p class="asb-help">Check the size, spelling and layout carefully. We print exactly what you approve here.</p>' +
  '<div class="asb-approve">' +
    '<div class="asb-approve__proof" data-asb-proof></div>' +
    '<div class="asb-approve__side">' +
      '<ul class="asb-approve__specs" data-asb-specs role="list"></ul>' +
      '<label class="asb-field"><span class="asb-field__label">Full name</span><input class="asb-input" name="name" autocomplete="name" required data-asb-name></label>' +
      '<div class="asb-two">' +
        '<label class="asb-field"><span class="asb-field__label">Email</span><input class="asb-input" type="email" name="email" autocomplete="email" required data-asb-email></label>' +
        '<label class="asb-field"><span class="asb-field__label">Phone</span><input class="asb-input" type="tel" name="phone" autocomplete="tel" required data-asb-phone></label>' +
      '</div>' +
      '<div class="asb-field">' +
        '<span class="asb-field__label">Your signature</span>' +
        '<div class="asb-sig-tabs" role="group" aria-label="How do you want to sign?">' +
          '<button type="button" class="asb-tab" data-asb-mode="draw" aria-pressed="false">Draw it</button>' +
          '<button type="button" class="asb-tab" data-asb-mode="type" aria-pressed="true">Type it</button>' +
        '</div>' +
        '<div class="asb-sig-type" data-asb-type>' +
          '<input class="asb-input" data-asb-sig-text autocomplete="name" placeholder="Type your full name" aria-label="Type your signature">' +
          '<div class="asb-sig-type__preview" data-asb-sig-preview aria-hidden="true"></div>' +
        '</div>' +
        '<div class="asb-sig" data-asb-draw hidden>' +
          '<canvas class="asb-sig__pad" data-asb-pad aria-label="Signature box. Draw your signature with your finger or mouse." role="img"></canvas>' +
          '<button type="button" class="asb-mini asb-sig__clear" data-asb-clear>Clear</button>' +
        '</div>' +
      '</div>' +
      '<label class="asb-check"><input type="checkbox" data-asb-colors> <span>I understand printed colors may vary slightly from what I see on my screen.</span></label>' +
      '<p class="asb-error" data-asb-error role="alert" hidden></p>' +
      '<button type="submit" class="asb-btn asb-btn--primary asb-btn--block" data-asb-submit disabled>Approve and add to cart</button>' +
      '<p class="asb-help asb-help--todo" data-asb-todo aria-live="polite"></p>' +
      '<button type="button" class="asb-btn asb-btn--secondary asb-btn--block" data-asb-back>Go back and make changes</button>' +
      '<p class="asb-help">By signing, you approve this proof for printing. Your signed proof is saved with your order.</p>' +
    '</div>' +
  '</div>' +
  '</form>';

function $(s) { return dlg.querySelector(s); }
function $$(s) { return Array.prototype.slice.call(dlg.querySelectorAll(s)); }

function build() {
  if (dlg) return;
  dlg = document.createElement('dialog');
  dlg.className = 'asb-dialog asb-dialog--wide';
  dlg.setAttribute('aria-labelledby', 'AsbApproveTitle');
  dlg.innerHTML = HTML;
  document.body.appendChild(dlg);
  bindSig();
  $$('[data-asb-mode]').forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-asb-mode')); }); });
  $('[data-asb-sig-text]').addEventListener('input', function (e) { $('[data-asb-sig-preview]').textContent = e.target.value; $('[data-asb-type]').classList.remove('is-missing'); });
  $('[data-asb-form]').addEventListener('submit', submit);
  $('[data-asb-form]').addEventListener('input', function () { $('[data-asb-error]').hidden = true; refresh(); });
  $('[data-asb-form]').addEventListener('change', refresh);
  $('[data-asb-close]').addEventListener('click', function () { close(null); });
  $('[data-asb-back]').addEventListener('click', function () { close(null); });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(null); });
  if (typeof ResizeObserver !== 'undefined') {
    try { new ResizeObserver(function () { if (sig.mode === 'draw' && !sig.ink) sizeSig(); }).observe($('[data-asb-draw]')); } catch (er) {}
  }
  if (window.ArdorProofLater) window.ArdorProofLater.refresh(); // DSN Oct 25 2026: one approval box; name + typed signature in the cart
    if (window.ArdorArtLink) window.ArdorArtLink.refresh(); // ART0: add the "Email me the proof to approve" choice to the new dialog
}

function loadSigFont() {
  if (document.querySelector('link[data-asb-sig-font]')) return;
  var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-asb-sig-font', '');
  l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
  document.head.appendChild(l);
}

function setMode(mode) {
  sig.mode = mode;
  $$('[data-asb-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-asb-mode') === mode ? 'true' : 'false'); });
  $('[data-asb-type]').hidden = mode !== 'type';
  $('[data-asb-draw]').hidden = mode !== 'draw';
  if (mode === 'draw') sizeSig();
  if (mode === 'type') {
    var t = $('[data-asb-sig-text]');
    if (!t.value) t.value = ($('[data-asb-name]').value || '').trim();
    $('[data-asb-sig-preview]').textContent = t.value;
  }
  refresh();
}

function sizeSig() {
  var cv = $('[data-asb-pad]'), dpr = Math.min(2, window.devicePixelRatio || 1);
  cv.width = Math.max(200, Math.round((cv.clientWidth || 300) * dpr)); cv.height = Math.round(150 * dpr);
  var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
  sig.ink = false;
  refresh();
}

function bindSig() {
  var cv = $('[data-asb-pad]');
  var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  cv.addEventListener('pointerdown', function (e) {
    sig.drawing = true; var p = pos(e); sig.lx = p[0]; sig.ly = p[1];
    try { cv.setPointerCapture(e.pointerId); } catch (er) {}
    $('[data-asb-error]').hidden = true;
    e.preventDefault();
  });
  cv.addEventListener('pointermove', function (e) {
    if (!sig.drawing) return;
    var p = pos(e), ctx = cv.getContext('2d');
    ctx.beginPath(); ctx.moveTo(sig.lx, sig.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
    sig.lx = p[0]; sig.ly = p[1];
    if (!sig.ink) { sig.ink = true; $('[data-asb-draw]').classList.remove('is-missing'); refresh(); }
  });
  var end = function () { sig.drawing = false; };
  cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
  $('[data-asb-clear]').addEventListener('click', function () { sizeSig(); });
}

function typedSigCanvas(text) {
  var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
  var ctx = cv.getContext('2d'), size = 120;
  ctx.font = '600 ' + size + 'px ' + SIG_FONT;
  while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
  ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
  return cv;
}

function missing() {
    var PL = window.ArdorProofLater; if (PL && PL.on()) return $('[data-asb-colors]').checked ? [] : ['a check in the approval box']; // DSN
  var out = [];
  var name = ($('[data-asb-name]').value || '').trim(), email = ($('[data-asb-email]').value || '').trim(), phone = ($('[data-asb-phone]').value || '').trim();
  if (name.length < 2) out.push('your full name');
  if (!/^\S+@\S+\.\S+$/.test(email)) out.push('a valid email');
  if ((phone.match(/\d/g) || []).length < 7) out.push('a phone number');
  if (sig.mode === 'draw' && !sig.ink) out.push('your signature');
  if (sig.mode === 'type' && ($('[data-asb-sig-text]').value || '').trim().length < 2) out.push('your typed signature');
  if (!$('[data-asb-colors]').checked) out.push('a check in the color box');
  return out;
}

function refresh() {
  if (!dlg) return;
  var AL = window.ArdorArtLink, R = document.querySelector('[data-wss]'); // ART0
  if (AL && AL.emailChosen(R)) { $('[data-asb-submit]').disabled = false; $('[data-asb-todo]').textContent = ''; return; } // ART0: an emailed proof needs only the email (checked on submit)
  var m = missing();
  $('[data-asb-submit]').disabled = m.length > 0;
  $('[data-asb-todo]').textContent = m.length ? 'To approve, add ' + m.join(', ') + '.' : '';
}

function remember(name, email, phone) {
  try { sessionStorage.setItem('ardorProofSigner', JSON.stringify({ name: name, email: email, phone: phone })); } catch (e) {}
}
function recall() {
  try { return JSON.parse(sessionStorage.getItem('ardorProofSigner') || 'null'); } catch (e) { return null; }
}

function open(info) {
  build();
  return new Promise(function (resolve, reject) {
    if (ctl) ctl.reject({ cancel: true });
    ctl = { resolve: resolve, reject: reject };
    var box = $('[data-asb-proof]'); box.textContent = '';
    var fig = document.createElement('figure'); fig.className = 'asb-approve__fig';
    var im = new Image(); im.alt = 'Your sticker proof'; im.src = info.canvas.toDataURL('image/jpeg', 0.88);
    var cap = document.createElement('figcaption'); cap.textContent = info.caption || '';
    fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
    var ul = $('[data-asb-specs]'); ul.textContent = '';
    (info.specs || []).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
    var prev = recall();
    if (prev) {
      if (!$('[data-asb-name]').value) $('[data-asb-name]').value = prev.name || '';
      if (!$('[data-asb-email]').value) $('[data-asb-email]').value = prev.email || '';
      if (!$('[data-asb-phone]').value) $('[data-asb-phone]').value = prev.phone || '';
    }
    $('[data-asb-error]').hidden = true;
    $('[data-asb-colors]').checked = false;
    loadSigFont();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    setMode(coarse ? 'draw' : 'type');
    refresh();
  });
}

function close(result) {
  if (dlg) { if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  var c = ctl; ctl = null;
  if (!c) return;
  if (result) c.resolve(result); else c.reject({ cancel: true });
}

function submit(e) {
  e.preventDefault();
  var AL = window.ArdorArtLink, R = document.querySelector('[data-wss]'); // ART0
  if (AL && AL.emailChosen(R)) { var pe = AL.proofEmail(R); if (pe) { var at0 = new Date(); close({ emailProof: true, email: pe, at: at0, when: stampLabel(at0) }); } return; } // ART0: emailed proof, no signature
    var PL = window.ArdorProofLater; if (PL && PL.on()) { if (!$('[data-asb-colors]').checked) { var er = $('[data-asb-error]'); er.textContent = 'Please check the box to approve your proof.'; er.hidden = false; return; } close(PL.result()); return; } // DSN
  var m = missing();
  if (m.length) {
    if (sig.mode === 'draw' && !sig.ink) $('[data-asb-draw]').classList.add('is-missing');
    if (sig.mode === 'type' && ($('[data-asb-sig-text]').value || '').trim().length < 2) $('[data-asb-type]').classList.add('is-missing');
    var err = $('[data-asb-error]'); err.textContent = 'Please add ' + m.join(', ') + '.'; err.hidden = false;
    return;
  }
  var name = $('[data-asb-name]').value.trim(), email = $('[data-asb-email]').value.trim(), phone = $('[data-asb-phone]').value.trim();
  var typed = ($('[data-asb-sig-text]').value || '').trim();
  var at = new Date(), when = stampLabel(at), mode = sig.mode;
  remember(name, email, phone);
  var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
  fontReady.then(function () {
    var copy;
    if (mode === 'type') copy = typedSigCanvas(typed);
    else { var src = $('[data-asb-pad]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
    close({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: STATEMENTS.slice() });
  });
}

var pdfLoad = null;
function loadPdfTool() {
  if (window.ArdorStickerPDF) return Promise.resolve();
  if (pdfLoad) return pdfLoad;
  pdfLoad = new Promise(function (res, rej) {
    var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
    sc.onload = function () { res(); }; sc.onerror = function () { pdfLoad = null; rej(new Error('pdf tool')); };
    document.head.appendChild(sc);
  });
  return pdfLoad;
}
function logoImage() {
  if (!CONF.logoUrl) return Promise.resolve(null);
  return fetch(CONF.logoUrl).then(function (r) { return r.blob(); }).then(function (bl) {
    return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
  }).catch(function () { return null; });
}
function buildProofPdf(info, ap) {
  return loadPdfTool().then(logoImage).then(function (logo) {
    return window.ArdorStickerPDF.buildProof({
      logo: logo,
      title: 'Ardor Sticker Proof',
      date: ap ? ap.when : stampLabel(new Date()),
      approval: ap || null,
      faces: [{ label: info.label || 'Your sticker', canvas: info.canvas, pad: info.pad || 0, wLabel: info.wLabel, hLabel: info.hLabel, frame: false }],
      specs: info.specs || [],
      specsTitle: 'Your stickers',
      legend: info.legend || [],
      note: info.note || '',
      footer: FOOTER,
      disclaimer: DISCLAIMER
    });
  });
}

function post(fd, onProgress) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', CONF.cartAddUrl);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.upload.onprogress = function (e) { if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total); };
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) return resolve();
      var msg = 'We couldn\'t add this to your cart. Please try again, or contact us.';
      try { var j = JSON.parse(xhr.responseText); if (j && j.description) msg = j.description; } catch (e) {}
      reject(new Error(msg));
    };
    xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
    xhr.send(fd);
  });
}

window.ArdorStickerApprove = { open: open, buildProofPdf: buildProofPdf, post: post, stampLabel: stampLabel, stampFile: stampFile };
})();
